import { takeEvery, put, select, fork } from 'redux-saga/effects';

import { touchForm, unTouchForm } from './actions';
import {
  REDUX_FORM_CHANGE,
  REDUX_FORM_FOCUS,
  REDUX_FORM_BLUR,
  REDUX_FORM_SET_SUBMIT_FAILED,
  SUBMIT_IS_FAILED,
  REDUX_FORM_INITIALIZE,
} from './constants';
import { getCustomFormIsTouched } from './selectors';
function* setSubmitFailed() {
  yield put(unTouchForm());
}
function* setFormTouched() {
  const alreadyTouched = yield select(getCustomFormIsTouched());
  if (!alreadyTouched) {
    yield put(touchForm());
  }
}
export default function* () {
  yield [
    takeEvery( REDUX_FORM_SET_SUBMIT_FAILED, setSubmitFailed),
    takeEvery( SUBMIT_IS_FAILED, setSubmitFailed),
    takeEvery( REDUX_FORM_CHANGE, setFormTouched),
    takeEvery( REDUX_FORM_INITIALIZE, setFormTouched),
    takeEvery( REDUX_FORM_FOCUS, setFormTouched),
    takeEvery( REDUX_FORM_BLUR, setFormTouched),
  ];
}
